import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { api, messageErreur } from "@/lib/api";

const TOKENS = ["--bg", "--surface", "--surface-2", "--line", "--ink", "--muted", "--accent", "--accent-ink", "--danger", "--success", "--shadow",
  "--radius-card", "--radius-control", "--radius-pill", "--font", "--temp-1", "--temp-2", "--temp-3", "--temp-4", "--temp-5", "--temp-6", "--temp-7"];

const MESURE = "<script>(function(){var d=function(){var b=document.body;if(!b)return;var m=0;for(var i=0;i<b.children.length;i++){var r=b.children[i].getBoundingClientRect();m=Math.max(m,r.bottom+scrollY)}var s=getComputedStyle(b);parent.postMessage({airthermo_hauteur:1,h:m+parseFloat(s.paddingBottom||0)+parseFloat(s.marginBottom||0)+2},'*')};addEventListener('load',function(){d();new MutationObserver(d).observe(document.body,{childList:true,subtree:true,characterData:true});[300,1000,2500].forEach(function(t){setTimeout(d,t)})});})();</script>";

const avecTheme = (html) => {
  const s = getComputedStyle(document.documentElement);
  const vars = TOKENS.map((t) => `${t}:${s.getPropertyValue(t).trim()}`).filter((x) => !x.endsWith(":")).join(";").replace(/[<>]/g, "");
  return html.replace("<head>", `<head><style>:root{${vars}}</style>${MESURE}`);
};

export const HoteOutil = ({ outil, contexte = {}, hauteur = 520, testId }) => {
  const ref = useRef(null);
  const ctx = useRef(contexte);
  const [h, setH] = useState(null);
  ctx.current = contexte;
  const doc = useMemo(() => avecTheme(outil.html), [outil.html]);
  useEffect(() => {
    const ecouter = async (e) => {
      if (!ref.current || e.source !== ref.current.contentWindow) return;
      const m = e.data;
      if (m?.airthermo_hauteur === 1 && Number.isFinite(m.h)) { setH(Math.min(hauteur, Math.max(80, Math.ceil(m.h)))); return; }
      if (!m || m.airthermo !== 1 || !["lire", "action"].includes(m.type)) return;
      const repondre = (r) => ref.current?.contentWindow?.postMessage({ airthermo_reponse: 1, id: m.id, ...r }, "*");
      try {
        const { data } = await api.post(`/outils/${outil.id}/pont`, { type: m.type, ressource: m.ressource, action: m.action, params: m.params, contexte: ctx.current });
        repondre({ donnees: data.donnees });
      } catch (x) { repondre({ erreur: messageErreur(x) }); }
    };
    window.addEventListener("message", ecouter);
    return () => window.removeEventListener("message", ecouter);
  }, [outil.id, hauteur]);
  const cle = `${outil.id}-${outil.version_active}-${contexte.fiche_id || ""}-${contexte.processus_id || ""}`;
  return (
    <iframe key={cle} ref={ref} title={outil.nom} srcDoc={doc} sandbox="allow-scripts" referrerPolicy="no-referrer"
      className="w-full block border-0" style={{ height: h || hauteur, borderRadius: "var(--radius-card)", background: "var(--bg)" }} data-testid={testId || `tool-frame-${outil.id}`} />
  );
};

export const HoteOutilParId = ({ id, contexte, hauteur }) => {
  const [o, setO] = useState(null);
  const [err, setErr] = useState(null);
  const charger = useCallback(() => api.get(`/outils/${id}`).then((r) => setO(r.data)).catch((x) => setErr(messageErreur(x))), [id]);
  useEffect(() => { charger(); }, [charger]);
  if (err) return <p className="text-sm at-muted" data-testid="tool-error">{err}</p>;
  return o ? <HoteOutil outil={o} contexte={contexte} hauteur={hauteur} /> : null;
};

export const OutilsEpingles = ({ lieu, contexte, titre }) => {
  const [l, setL] = useState([]);
  useEffect(() => { api.get("/outils/epingles", { params: { lieu } }).then((r) => setL(r.data)).catch(() => setL([])); }, [lieu]);
  if (!l.length) return null;
  return (
    <section className="space-y-3 min-w-0" data-testid={`pinned-tools-${lieu}`}>
      {titre && <p className="at-label">{titre}</p>}
      {l.map((o) => (
        <div key={o.id} className="at-card p-2 min-w-0" data-testid={`pinned-tool-${lieu}-${o.id}`}>
          <HoteOutil outil={o} contexte={contexte} hauteur={lieu === "fiche" ? 820 : 480} />
        </div>
      ))}
    </section>
  );
};
